// extracted by mini-css-extract-plugin
export default {"container":"sideMenu_container__Eme0l","hidden":"sideMenu_hidden__wX4Uy","content":"sideMenu_content__QkrNM","toggleButton":"sideMenu_toggleButton__KpVFf"};